import { render, staticRenderFns } from "./reportbroken.vue?vue&type=template&id=64b0ffd9&"
import script from "./reportbroken.vue?vue&type=script&lang=js&"
export * from "./reportbroken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports